import { GERMANY_CONTRACT_ADDENDUM_TYPES } from '../../../../../../shared/constants'

export const statusOptions = [
  { label: 'Active', value: 1 },
  { label: 'Expired', value: 2 },
  { label: 'Pending', value: 3 },
  { label: 'Not signed', value: 4 },
  { label: 'Pending extension', value: 5 },
  { label: 'Concluded', value: 6 },
]

export const typeSuffixMap = {
  GERMANY_WORKING_STUDENT: 'WS',
  GERMANY_PART_TIME: 'PT',
  GERMANY_SHORT_TERM: 'ST',
  GERMANY_MARGINAL_PART_TIME: 'MJ',
}

export const hoursPerWeekOptions = [
  { label: '6', value: 6 },
  { label: '9', value: 9 },
  { label: '12', value: 12 },
  { label: '15', value: 15 },
  { label: '18', value: 18 },
  { label: '21', value: 21 },
  { label: '24', value: 24 },
  { label: '27', value: 27 },
  { label: '30', value: 30 },
  { label: '33', value: 33 },
  { label: '36', value: 36 },
]

export const addendumTypeOptions = [
  {
    label: 'Change of amount of working hours',
    value: GERMANY_CONTRACT_ADDENDUM_TYPES.CHANGE_AMOUNT_HOURS,
  },
  {
    label: 'Contract Extension',
    value: GERMANY_CONTRACT_ADDENDUM_TYPES.CONTRACT_EXTENSION,
  },
  {
    label: 'Immediate Resignation',
    value: GERMANY_CONTRACT_ADDENDUM_TYPES.IMMEDIATE_RESIGNATION,
  },
  {
    label: 'Future resignation (future date)',
    value: GERMANY_CONTRACT_ADDENDUM_TYPES.FUTURE_RESIGNATION,
  },
  {
    label: `Promofy Immediate Termination - Fristlose Kuendigung (Employee doesn't show up for work)`,
    value: GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_DOESNT_SHOW_UP,
  },
  {
    label: `Promofy Immediate termination - Fristlose Kuendigung (Employee doesn't send resignation letter)`,
    value: GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_DOESNT_SEND_LETTER,
  },
  {
    label: 'Termination (employee within 6 month probation period)',
    value: GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_LESS_THAN_6_MONTH,
  },
  {
    label: 'Termination (employee employed more than 6 months)',
    value: GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_MORE_THAN_6_MONTH,
  },
]

export const ADDENDUM_NAMES_MAP = {
  [GERMANY_CONTRACT_ADDENDUM_TYPES.CHANGE_AMOUNT_HOURS]:
    'Change of amount of working hours',
  [GERMANY_CONTRACT_ADDENDUM_TYPES.CONTRACT_EXTENSION]: 'Contract Extension',
  [GERMANY_CONTRACT_ADDENDUM_TYPES.IMMEDIATE_RESIGNATION]:
    'Immediate Resignation',
  [GERMANY_CONTRACT_ADDENDUM_TYPES.FUTURE_RESIGNATION]:
    'Future resignation (future date)',
  [GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_DOESNT_SHOW_UP]: `Promofy Immediate Termination - Fristlose Kuendigung (Employee doesn't show up for work)`,
  [GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_DOESNT_SEND_LETTER]: `Promofy Immediate termination - Fristlose Kuendigung (Employee doesn't send resignation letter)`,
  [GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_LESS_THAN_6_MONTH]:
    'Termination (employee within 6 month probation period)',
  [GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_MORE_THAN_6_MONTH]:
    'Termination (employee employed more than 6 months)',
}
